<template>
<el-dialog title="选择采购部长" width="50%" :append-to-body="true" :visible.sync="viewData.visible" :close-on-click-modal="false" v-loading="loading">
    <div class="user-settings">
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="small" :header-cell-style="{background:'#f5f5f5'}" style="width: 100%;" border>
                <el-table-column label="选择" width="50" align="center">
                     <template slot-scope="scope">
                              <el-radio v-model="currentFactor" :label="scope.row" @input="clickChange">{{ "" }}</el-radio>
                     </template>
                </el-table-column>
                <el-table-column type="index" header-align="left" align="left" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="positionName" header-align="center" align="left" min-width="200" label="岗位名称">
                </el-table-column>
                <el-table-column prop="realName" header-align="center" align="left" min-width="200" label="用户名称">
                </el-table-column>
            </el-table>
        </div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewData.visible = false">
            取消
        </el-button>
        <!-- 选择用户确定添加 -->
        <el-button size="small" type="primary" @click="confirm()">
            确认
        </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    DIALOG_CLOSED_TYPE
} from '@/utils/const';
import {
    getPurchaseLeaderList
} from "@/controller/sys";

export default {
    props: {
        basicFormData: Object,
    },
    data() {
        return {
            loading: false,
            viewData: {
                visible: false,
                width: ''
            },
            dataList: [],
            userList: [],
            ids: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            DIALOG_CLOSED_TYPE: DIALOG_CLOSED_TYPE,
            dataListLoading: false,
            dataListSelections: [],
            currentFactor: '',//单选框的v-model值
        }
    },
    mounted() {},
    activated() {
    },
    methods: {
        open(leaderList) {
            this.viewData.visible = true
            this.pageSize = 10
            this.pageIndex = 1
            this.dataList = leaderList
        },
        onClosed(params) {
            console.log(params)
            return;
        },
        // 筛选按钮弹框取消
        cancel() {
            this.close();
        },
        close(option = DIALOG_CLOSED_TYPE.CLOSE) {
            if (!this.viewData.visible) {
                return;
            }

            this.onClosed({
                option,
                sender: this,
                data: "OK",
            });
            this.viewData.visible = false;
        },
        confirm() {
            console.log("this.userList===="+this.userList)
            if (this.userList == 'undefined' || this.userList.length == 0) {
                this.$message({
                    message: '请选择一条数据添加',
                    type: 'warning'
                })
                return false
            } else if (this.userList.length == 1) {
                //将选择的数据添加到列表
                this.$emit('setPurchaseLeader', this.userList)
                this.viewData.visible = false;
            }
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true,
            getPurchaseLeaderList().then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body
                    console.log('this.dataList', this.dataList)
                } else {
                    this.dataList = []
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        clickChange(row) {
            console.log(row);
            this.userList[0] = row
        },
    }
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}

.el-table__body {
    tr.current-row>td {
        color: #fff;
        background-color: #409EFF !important;
    }
}

.fr {
    float: right;
}

.mt15 {
    margin-top: 15px;
}

.mb {
    margin-bottom: 15px;
}
</style>
